// KeepAlive.tsx — no change needed, already perfect ✅
"use client";
import { useKeepAlive } from "@/hooks/useKeepAlive";
export default function KeepAlive() {
    useKeepAlive();
    return null;
}